import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import SchemaOrg from '@/components/base/SchemaOrg';
import { testimonials } from '@/mocks/faq';

export default function AboutPage() {
  return (
    <>
      <SchemaOrg
        type="WebPage"
        data={{
          name: '关于我们 - 91爆料网',
          description: '91爆料网致力于为用户提供全网最新最热的爆料资讯。了解我们的品牌故事、用户口碑与联系方式。',
          url: 'http://gm3pta.cn/about',
        }}
      />
      <SchemaOrg
        type="BreadcrumbList"
        data={{
          itemListElement: [
            { '@type': 'ListItem', position: 1, name: '首页', item: 'http://gm3pta.cn/' },
            { '@type': 'ListItem', position: 2, name: '关于我们', item: 'http://gm3pta.cn/about' },
          ],
        }}
      />

      <Navbar />

      <main className="pt-16">
        <section className="bg-foreground-900">
          <div className="px-4 md:px-6 max-w-7xl mx-auto py-14 md:py-20">
            <span className="inline-block px-3 py-1 bg-accent-500/20 text-accent-300 text-xs rounded-full mb-4">
              关于我们
            </span>
            <h1 className="font-heading text-3xl md:text-5xl font-bold text-background-50 mb-6 max-w-2xl">
              做全网最专业的<span className="text-primary-400">吃瓜平台</span>
            </h1>
            <p className="text-foreground-300 text-sm md:text-base max-w-2xl leading-relaxed">
              91爆料网成立于2023年，致力于为吃瓜群众提供最新、最快、最真实的爆料资讯。
              我们的编辑团队全天候追踪全网热点，用最敏锐的嗅觉和最严格的核实流程，为千万用户呈现精彩的吃瓜内容。
            </p>
          </div>
        </section>

        <section className="py-10 md:py-14 bg-background-50">
          <div className="px-4 md:px-6 max-w-7xl mx-auto">
            <Breadcrumb currentPage="关于我们" />

            <div className="flex flex-col lg:flex-row gap-10 lg:gap-16 mt-8">
              <div className="lg:w-2/5">
                <div className="rounded-lg overflow-hidden h-[300px] md:h-[400px]">
                  <img
                    src="https://readdy.ai/api/search-image?query=Modern%20editorial%20office%20space%20with%20warm%20lighting%2C%20creative%20team%20brainstorming%2C%20professional%20yet%20casual%20atmosphere%2C%20warm%20coral%20and%20amber%20accents%2C%20clean%20minimal%20decor%2C%20soft%20natural%20light%20from%20large%20windows%2C%20premium%20editorial%20photography%20style&width=600&height=800&seq=about-brand&orientation=portrait"
                    alt="91爆料网办公环境"
                    className="w-full h-full object-cover"
                  />
                </div>
              </div>

              <div className="lg:w-3/5 flex flex-col justify-center">
                <div className="mb-8">
                  <h2 className="font-heading text-5xl md:text-7xl font-black text-primary-500 mb-3">5000+</h2>
                  <p className="text-foreground-600 text-sm leading-relaxed">
                    累计爆料文章数量，覆盖网红、娱乐、社会热点等多个领域，每篇都经过严格核实
                  </p>
                </div>
                <div className="mb-8">
                  <h2 className="font-heading text-5xl md:text-7xl font-black text-accent-500 mb-3">300万+</h2>
                  <p className="text-foreground-600 text-sm leading-relaxed">
                    月活跃用户数，他们每天在91爆料网上获取最新最热的吃瓜资讯
                  </p>
                </div>
                <Link
                  to="#contact"
                  className="self-start px-6 py-3 bg-foreground-950 text-background-50 rounded-full text-sm font-medium hover:bg-foreground-800 transition-colors duration-200 whitespace-nowrap cursor-pointer"
                >
                  联系我们
                </Link>
              </div>
            </div>
          </div>
        </section>

        <section className="py-14 md:py-20 bg-background-100">
          <div className="px-4 md:px-6 max-w-7xl mx-auto">
            <div className="text-center mb-12">
              <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-4">
                用户<span className="text-accent-500">口碑</span>
              </h2>
              <p className="text-foreground-500 text-sm md:text-base max-w-xl mx-auto leading-relaxed">
                听听吃瓜群众们怎么说
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
              {testimonials.map((t, i) => (
                <div
                  key={i}
                  className="bg-background-50 border border-background-200/70 rounded-lg p-6"
                >
                  <div className="flex items-center gap-1 mb-3">
                    {[...Array(t.rating)].map((_, j) => (
                      <i key={j} className="ri-star-fill text-accent-500 text-sm"></i>
                    ))}
                  </div>
                  <p className="text-foreground-600 text-sm leading-relaxed mb-4">
                    "{t.content}"
                  </p>
                  <div className="flex items-center gap-3">
                    <div className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center text-primary-500 font-bold text-sm">
                      {t.name[0]}
                    </div>
                    <div>
                      <p className="text-foreground-900 text-sm font-semibold">{t.name}</p>
                      <p className="text-foreground-400 text-xs">{t.role}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}